import { useCallback, useEffect, useRef, useState } from 'react';

import useLatestCallback from './useLatestCallback';

export const PostMessageStatus = {
  IDLE: 'PENDING',
  IN_PROCESS: 'IN_PROCESS',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  FAILED_GET: 'FAILED_GET',
};

export default function usePostMessage(onCommand, runImmediately = true) {
  const onCommandLatestCallback = useLatestCallback(onCommand);

  const formId_ref = useRef(null);
  const frameId_ref = useRef(null);
  const port2_ref = useRef(null);

  const [postStatus, setPostStatus] = useState(PostMessageStatus.IDLE);
  const [runnable, setRunnable] = useState(runImmediately);

  const postMessage = useCallback((message) => {
    if (port2_ref.current) {
      const formId = formId_ref.current;
      const id = frameId_ref.current;
      const msg = {
        command: 'EXECUTE',
        controlId: id,
        formId,
        params: { id, formId, command: message },
      };

      port2_ref.current.postMessage(msg);
    }
  }, []);

  const receiveMessage = useCallback(
    (event) => {
      if (event.data.command) {
        const { command, params } = event.data;
        if (command === 'EXECUTE') {
          const message = params.command;
          onCommandLatestCallback(message);
        }
      }
    },
    [onCommandLatestCallback]
  );

  const onInit = useCallback(
    (event) => {
      //Receive the first message for set up port and width/height
      if (event.data.command) {
        const { command, params } = event.data;
        if (command === 'INIT') {
          const { id, formId = 'PARENT' } = params;
          frameId_ref.current = id;
          formId_ref.current = formId;

          port2_ref.current = event.ports[0];
          port2_ref.current.onmessage = receiveMessage;
          port2_ref.current.postMessage({
            command: 'INITIALIZED',
            controlId: id,
            formId,
            params: { id, formId },
          });
          setPostStatus(PostMessageStatus.SUCCESS);
        }
      }
    },
    [receiveMessage]
  );

  useEffect(() => {
    if (runnable) {
      setPostStatus(PostMessageStatus.IN_PROCESS);
      window.addEventListener('message', onInit);
      return () => {
        window.removeEventListener('message', onInit);
        setRunnable(false);
        setPostStatus(PostMessageStatus.IDLE);
      };
    }
  }, [onInit, runnable]);

  return { postMessage, postStatus };
}
